/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Combo_BadgeInputs */

const vi_product_combo_badge = /** @type {(inputs: Product_Combo_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combo`)
};

/**

* @param {Product_Combo_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_combo_badge = /** @type {((inputs?: Product_Combo_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Combo_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_combo_badge(inputs)
});